import { useTranslation } from 'next-i18next'

import SelectorItem from '~/components/SelectorItem/SelectorItem'
import { Product } from '~/types/product'
import { formatThousands } from '~/utils/helpers'
import { getPrefix } from '~/booking/utils/booking.utils'

export default function ProductItem({
  includeTravelExpense,
  isSelected,
  onClick,
  product,
}: {
  includeTravelExpense: boolean
  isSelected: boolean
  onClick: (product: Product) => void
  product: Product
}): React.ReactElement {
  const { t } = useTranslation(['booking', 'tutorOnDemand'])
  const { priceHourly, priceTotal } = getProductPrices(product, includeTravelExpense)

  return (
    <SelectorItem isSelected={isSelected} onClick={() => onClick(product)}>
      <span className="mb-1 md:mb-2"> {t(`booking:tutorPackage.${product.type}`)}</span>
      <span className="flex flex-col items-center">
        <span className="lowercase text-hotpink">{priceHourly}</span>
        <span className="text-xs font-medium text-black-light lowercase">
          {t('tutorOnDemand:landingPage.productPrices.perHour')}
        </span>
        <span className="text-2.5 font-normal text-gray-medium">
          Total: {getPrefix(product.currency)} {priceTotal}
        </span>
      </span>
    </SelectorItem>
  )
}

function getProductPrices(
  product: Product,
  includeTravelExpense: boolean,
): { priceHourly: string; priceTotal: string } {
  const priceHourly = includeTravelExpense ? product.priceHourlyWithTravelExpense : product.priceHourly
  const priceTotal = includeTravelExpense ? product.priceTotalWithTravelExpense : product.price

  return {
    priceHourly: formatThousands(priceHourly),
    priceTotal: formatThousands(priceTotal.toFixed(2)),
  }
}
